import React from 'react'
import Header from 'application/presentation/common/Header/Header'
import { NavLink } from 'react-router-dom'

import s from './InformationPage.module.scss'

const InformationPage = () => {
  return (
    <>
      <Header title="Информация" />
      <div className={s.content}>
        <div className={s.text}>
          Сервис представляет информационные услуги по представлению автомоечных комплексов в
          России. Подробнее на сайте <a href="https://moyservice.com">moyservice.com</a>
          <br />
          <br />
          Услуги оказываются
          <br />
          ООО "МОЙ"
          <br />
          ИНН 2100014931
          <br />
          428003, РФ, Чувашская Республика, г. Чебоксары, проезд Базовый, д. 22, оф. 103
          <br />
          <br />
          Банк АО "АЛЬФА-БАНК"
          <br />
          БИК 042202824
          <br />
          р/с 40702810529040007445
          <br />
          кор/счёт 330101810200000000824
          <br />
          <br /> Услуги оказываются на основании <NavLink to="/offerta">договора оферты.</NavLink>
        </div>
      </div>
    </>
  )
}

export default React.memo(InformationPage)
